module.exports = __webpack_public_path__ + "static/img/brees-2002-slide-3.105c21c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2002-slide-3.jpg
// module id = 456n
// module chunks = 1